import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { filterSetsApi } from '../api/filter-sets.api';
import type { CreateFilterSetDto, UpdateFilterSetDto } from '../types';

export const useFilterSets = () => {
  return useQuery({
    queryKey: ['filterSets'],
    queryFn: () => filterSetsApi.getAll(),
  });
};

export const useFilterSet = (id: number) => {
  return useQuery({
    queryKey: ['filterSet', id],
    queryFn: () => filterSetsApi.getOne(id),
    enabled: !!id,
  });
};

export const useCreateFilterSet = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ data, file }: { data: CreateFilterSetDto; file?: File }) =>
      filterSetsApi.create(data, file),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['filterSets'] });
    },
  });
};

export const useUpdateFilterSet = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data, file }: { id: number; data: UpdateFilterSetDto; file?: File }) =>
      filterSetsApi.update(id, data, file),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['filterSets'] });
      queryClient.invalidateQueries({ queryKey: ['filterSet', variables.id] });
    },
  });
};

export const useDeleteFilterSet = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => filterSetsApi.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['filterSets'] });
      queryClient.invalidateQueries({ queryKey: ['home-tiles'] });
    },
  });
};

